<template>
  <!-- <Transition name="interface-appear" appear :@after-enter="onSlideComplete"> -->
  <div
    class="nav-search-ui__container"
    ref="container"
    :class="{ 'nav-search-ui__container--active': active }"
  >
    <div
      class="nav-search-ui__background"
      :class="{ 'nav-search-ui__background--active': active }"
    ></div>
    <component
      class="nav-search-ui__page-section"
      :is="
        GET_IS_ABOVE_BREAKPOINT('lg') ? 'div' : $options.components.PageSection
      "
      :class="{ 'nav-search-ui__page-section--active': active }"
      :uiColor="'#000'"
      :backgroundColor="'transparent'"
    >
      <div
        class="nav-search-ui__scroll-container"
        :class="{ 'nav-search-ui__scroll-container--active': active }"
        ref="scrollContainer"
      >
        <div class="nav-search-ui__content">
          <ais-instant-search
            :search-client="searchClient"
            :index-name="algoliaIndex('products')"
          >
            <ais-configure :query="query" :hitsPerPage="5" />
            <NavigationSearchInput
              class="nav-search-ui__input"
              v-model="query"
              ref="searchInput"
              @submit="handleInputSubmit"
            />
            <div class="nav-search-ui__results-container">
              <TransitionResults>
                <div
                  v-if="query.length > 1"
                  class="text-commerce-heading-3 text--clr-black mt-24"
                >
                  {{
                    UI_ELEMENT("search_results_counter", [
                      {
                        tag: "TOTAL_RESULTS",
                        value: totalResults
                      },
                      {
                        tag: "UNIT_SEARCH_RESULT",
                        value: UI_UNIT("unit_search_result", totalResults)
                      }
                    ])
                  }}
                </div>
              </TransitionResults>
              <!-- PRODUCTS - default index, declared above -->
              <NavSearchResultsProducts
                :key="`results_products`"
                :query="query"
                @results="hits => resultsHandler(hits, 'products')"
              />

              <!-- This is a bit static, but probably best for maintaining clarity of the results architecture -->
              <!-- SETS -->
              <ais-index :index-name="algoliaIndex('sets')">
                <NavSearchResultsProducts
                  :key="`results_sets`"
                  sets
                  :query="query"
                  @results="hits => resultsHandler(hits, 'sets')"
                />
              </ais-index>

              <!-- COLLECTIONS -->
              <ais-index :index-name="algoliaIndex('collections')">
                <NavSearchResultsCollections
                  :key="`results_collections`"
                  :query="query"
                  @results="hits => resultsHandler(hits, 'collections')"
                />
              </ais-index>

              <!-- PAGES -->
              <ais-index :index-name="algoliaIndex('pages')">
                <NavSearchResultsPages
                  :key="`results_pages`"
                  :query="query"
                  @results="hits => resultsHandler(hits, 'pages')"
                />
              </ais-index>
              <NavSearchResultsSuggestions :key="`results_suggestions`" />
            </div>
          </ais-instant-search>
        </div>
      </div>
      <button
        v-if="GET_IS_ABOVE_BREAKPOINT('lg') && active"
        class="nav-search-ui__close-cross"
        @click="$emit('close')"
      >
        <Cross class="locale-selector__close-cross-svg" />
      </button>
    </component>
  </div>
  <!-- </Transition> -->
</template>

<script>
import Vue from "vue"

import { mapGetters, mapState } from "vuex"

import AlgoliaAPI from "@/integration/AlgoliaAPI"

import { AisInstantSearch, AisConfigure, AisIndex } from "vue-instantsearch"

import NavigationSearchInput from "./NavigationSearchInput.vue"
import NavSearchResultsProducts from "./NavSearchResultsProducts.vue"
import NavSearchResultsCollections from "./NavSearchResultsCollections.vue"
import NavSearchResultsPages from "./NavSearchResultsPages.vue"
import NavSearchResultsSuggestions from "./NavSearchResultsSuggestions.vue"

import TransitionResults from "./NavigationSearchTransition_Results.vue"

import Cross from "@/assets/cross.svg"

// import { lockScroll, unlockScroll } from "@/helpers/ScrollLock"

export default {
  props: {
    active: Boolean
  },

  components: {
    AisInstantSearch,
    AisConfigure,
    AisIndex,
    NavigationSearchInput,
    NavSearchResultsProducts,
    NavSearchResultsCollections,
    NavSearchResultsPages,
    NavSearchResultsSuggestions,
    TransitionResults,
    Cross
  },

  data: () => ({
    searchClient: AlgoliaAPI.searchClient,
    query: "",
    resultsLengths: {},
    totalResults: 0,
    scrollableHeight: 0
  }),

  // mounted() {
  //   this.$refs["container"].addEventListener(
  //     "transitionend",
  //     this.onSlideComplete
  //   )
  // },

  // beforeDestroy() {
  //   this.$refs["container"].removeEventListener(
  //     "transitionend",
  //     this.onSlideComplete
  //   )
  // },

  methods: {
    resultsHandler(hits, type) {
      // TODO - without this check guard it spirals into an infinte death loop. Find out why
      // Probably because updating the data forces a re-render somewhere.
      // possibly related to https://github.com/algolia/vue-instantsearch/issues/663#issuecomment-489695804
      if (hits.length != this.resultsLengths[type]) {
        Vue.set(this.resultsLengths, type, hits.length || 0)
      }
    },

    algoliaIndex(type) {
      return process.env[`VUE_APP_ALGOLIA_INDEX_${type}`]
    },

    onSlideComplete(/* event */) {
      // console.log(event)
      if (this.active) {
        this.$refs["searchInput"].doFocus()
      }
    },

    handleInputSubmit(/* val */) {
      // TODO: Here we could add val to recent searches, stored in localStorage for this user
    }
  },

  computed: {
    ...mapState("locale", ["locale"]),
    ...mapState("scroll", ["viewportHeight"]),
    ...mapGetters("breakpoints", [
      "GET_IS_ABOVE_BREAKPOINT",
      "GET_IS_BELOW_BREAKPOINT"
    ]),

    getTotalResults() {
      return Object.values(this.resultsLengths).reduce((a, b) => a + b, 0)
    }
  },

  watch: {
    active(newVal) {
      if (!newVal) {
        this.query = ""
        // unlockScroll(this.$refs["scrollContainer"])
      } else {
        // lockScroll(this.$refs["scrollContainer"])
      }
    },

    resultsLengths: {
      handler(newVal) {
        this.totalResults = Object.values(newVal).reduce((a, b) => a + b, 0)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.nav-search-ui {
  &__container {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    // transform: translateY(0);
    &--active {
      pointer-events: all;
    }
  }

  &__background {
    background-color: getcolour(bleach_white);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    transition: height 0.3s ease;

    &--active {
      height: 100%;
      // pointer-events: all;
    }
  }

  &__page-section {
    height: 100%;
    opacity: 0;
    transition: opacity 0.1s linear 0.2s;

    &--active {
      opacity: 1;
      transition-delay: 0s;
    }
  }

  &__scroll-container {
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 100%;
    pointer-events: all;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding: 0 24px 24px;

    top: $nav-height-default;

    @include media-breakpoint-up(md) {
      top: $nav-height-md;
      padding: 0 40px 24px;
    }

    @include media-breakpoint-up(lg) {
      top: $nav-height-lg;
    }

    @include media-breakpoint-up(xl) {
      top: $nav-height-xl;
    }

    opacity: 0;
    pointer-events: none;
    transition: opacity 0.1s linear;

    &--active {
      transition-duration: 0.2s;
      transition-delay: 0.2s;
      opacity: 1;
      pointer-events: all;
    }
  }

  &__content {
    position: relative;
    width: 100%;
    min-height: calc(100% + 1px);
  }

  &__input {
    padding-top: 24px;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: getcolour(bleach_white);
    touch-action: none;
  }

  &__close-cross {
    position: absolute;
    pointer-events: all;
    z-index: 2;
    background-color: transparent;
    top: 15px;
    right: 20px;
    width: 26px;
    height: 26px;
    padding: 3px;
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 0;

    filter: drop-shadow(0 2px 3px getcolour(bleach_black));

    @include media-breakpoint-up(lg) {
      filter: unset;
    }

    // body:not(.mouse-nav) &:focus {
    //   outline: 2px solid getcolour(bleach_white);
    // }
  }
}

.interface-appear-enter-active,
.interface-appear-leave-active {
  .nav-search-ui {
    &__container {
      transition: transform 0.2s ease;
    }
  }
}

.interface-appear-enter,
.interface-appear-leave-to {
  .nav-search-ui {
    &__container {
      transform: translateX(0);
    }
  }
}
</style>
